var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-publication-brochure';
                    var viewUrl = 'sprite.svg#view-icon-publication-brochure';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 66',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };